import { CrudListView, PageContainer } from '@startupquickstart/frontend';
import { themeTypeCrudConfig } from '@/config/objects/theme-types';

export function ThemeTypesPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Theme Types', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView
        config={themeTypeCrudConfig}
        baseUrl="/theme-types"
        breadcrumbs={breadcrumbs}
      />
    </PageContainer>
  );
}
